module.exports = __webpack_public_path__ + "assets/72a7230ca16da52d00a739b7e6d675dc.mp3";